import { useState } from "react";

import { LoadingContent } from "components/bid_module/common_report_components/LoadingContent";
import ReportCollapse from "components/bid_module/common_report_components/ReportCollapse";
import FindEntity from "components/entities/FindEntity";
import { UseBidSupplierBuyerNoticeSummary } from "lib/hooks/api/bid/bids/useBid";
import { UseLeadSupplierBuyerNoticeSummary } from "lib/hooks/api/leads/useLead";
import { CoreNotice } from "../types";
import SupplierRelationshipCharts from "./SupplierRelationshipCharts";

export default function SupplierRelationships({
  isLoading,
  savedNotices,
  similarNotices,
  incumbentSupplierIds,
  noticesSearchUrl,
  objectId,
  queryProvider,
}: {
  isLoading: boolean;
  savedNotices: CoreNotice[];
  similarNotices: CoreNotice[];
  incumbentSupplierIds: string[];
  noticesSearchUrl: string;
  objectId: string;
  queryProvider: UseLeadSupplierBuyerNoticeSummary | UseBidSupplierBuyerNoticeSummary;
}) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <ReportCollapse
      title="Relationship history"
      open={isOpen}
      onOpenChange={setIsOpen}
      actions={!isOpen && isLoading ? <LoadingContent /> : null}
    >
      {savedNotices.length > 0 ? (
        <SupplierRelationshipCharts
          isLoading={isLoading}
          savedNotices={savedNotices}
          similarNotices={similarNotices}
          incumbentSupplierIds={incumbentSupplierIds}
          objectId={objectId}
          queryProvider={queryProvider}
        />
      ) : (
        <FindEntity entity="notice" url={noticesSearchUrl} isEmptyState />
      )}
    </ReportCollapse>
  );
}
